module.exports = __webpack_public_path__ + "img/bonuses.963bddbc.svg";